import React from "react";

const TypingDots = () => {
  const dotStyle = (delay: string) => ({
    width: "5px",
    height: "5px",
    margin: "0 1px",
    backgroundColor: "#555",
    borderRadius: "50%",
    display: "inline-block",
    animation: `bounce 1.4s infinite ease-in-out both`,
    animationDelay: delay,
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "24px",
        marginLeft: "4px",
      }}
    >
      <span style={dotStyle("0s")} />
      <span style={dotStyle("0.2s")} />
      <span style={dotStyle("0.4s")} />
      {/* Keyframes injected manually using a style tag */}
      <style>{`
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
            opacity: 0.3;
          }
          40% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default TypingDots;
